if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.product__description');
        this.toggleButton = this.querySelector('.product__description-toggle');
        this.toggleLabel = this.toggleButton
          ? this.toggleButton.querySelector('.product__description-toggle-text')
          : null;

        this.moreLabel = this.dataset.showMoreLabel || 'Mehr lesen';
        this.lessLabel = this.dataset.showLessLabel || 'Weniger anzeigen';
        this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 150;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.onResize = this.debounce(() => this.checkOverflow(), 150);
      }

      connectedCallback() {
        if (!this.content || !this.toggleButton) return;

        this.toggleButton.addEventListener('click', this.onToggleClick);
        this.content.addEventListener('transitionend', this.onTransitionEnd);
        window.addEventListener('resize', this.onResize);

        // Eine Frame warten, damit Layout/Fonts sich gesetzt haben, bevor gemessen wird.
        requestAnimationFrame(() => this.checkOverflow());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      checkOverflow() {
        if (!this.content || this.hasAttribute('open')) return;

        const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
        this.classList.toggle('is-overflowing', isOverflowing);
        this.toggleButton.hidden = !isOverflowing;
      }

      onTransitionEnd(event) {
        if (event.propertyName !== 'max-height') return;
        // Nach dem Aufklappen die feste Höhe entfernen, damit später nachladende
        // Inhalte (z. B. Bilder im Rich-Text) nicht abgeschnitten werden.
        if (this.hasAttribute('open')) {
          this.content.style.maxHeight = 'none';
        }
      }

      onToggleClick() {
        const isOpen = this.hasAttribute('open');

        if (isOpen) {
          // Von 'none' zurück auf einen konkreten Pixelwert setzen, damit
          // die CSS-Transition beim Einklappen wieder greift.
          this.content.style.maxHeight = `${this.content.scrollHeight}px`;
          requestAnimationFrame(() => {
            this.content.style.maxHeight = `${this.collapsedHeight}px`;
          });

          this.removeAttribute('open');
          this.toggleButton.setAttribute('aria-expanded', 'false');
          if (this.toggleLabel) this.toggleLabel.textContent = this.moreLabel;
        } else {
          this.content.style.maxHeight = `${this.content.scrollHeight}px`;

          this.setAttribute('open', '');
          this.toggleButton.setAttribute('aria-expanded', 'true');
          if (this.toggleLabel) this.toggleLabel.textContent = this.lessLabel;
        }
      }

      debounce(fn, wait) {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => fn(...args), wait);
        };
      }
    }
  );
}
